<template>
  <div class="pb-5">
    <legend>Заказы</legend>
    <div class="form-group row">
      <div class="col" style="max-width: 200px!important;">
        <date-picker :first-day-of-week="1" :input-attr="{required: true}" class="w-100"
                     input-class="form-control"
                     lang="ru"
                     placeholder="С"
                     v-model="from" valueType="format">
        </date-picker>
      </div>
      <div class="col" style="max-width: 200px!important;">
        <date-picker :first-day-of-week="1" :input-attr="{required: true}" class="w-100"
                     input-class="form-control"
                     lang="ru"
                     placeholder="По"
                     v-model="to" valueType="format">
        </date-picker>
      </div>
      <div class="col">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button class="btn" :class="dateMode === 'delivery_date' ? 'btn-primary' : 'btn-outline-primary'" @click="dateMode = 'delivery_date'">По дате доставки</button>
          <button class="btn" :class="dateMode === 'dispatch_date' ? 'btn-primary' : 'btn-outline-primary'" @click="dateMode = 'dispatch_date'">По дате отправки</button>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col" style="max-width: 300px;">
        <label>Категория</label>
        <select class="form-control" v-model="currentCustomerCategory">
          <option value=""></option>
          <option :key="customerCategory.Id" :value="customerCategory.Id"
                  v-for="customerCategory in customerCategories">
            {{customerCategory.Name}}
          </option>
        </select>
      </div>
      <div class="col" style="max-width: 300px;">
        <label>Статус заказа</label>
        <select class="form-control" v-model="currentOrderStatus">
          <option value=""></option>
          <option :key="orderStatus.Id" :value="orderStatus.Id"
                  v-for="orderStatus in orderStatuses">
            {{orderStatus.Name}}
          </option>
        </select>
      </div>
      <div class="col" style="max-width: 300px;">
        <label>Оплачено</label>
        <select class="form-control" v-model="isPaid">
          <option value=""></option>
          <option :value="true">Да</option>
          <option :value="false">Нет</option>
        </select>
      </div>
      <div class="col" style="max-width: 300px;">
        <label>Получено</label>
        <select class="form-control" v-model="isPassed">
          <option value=""></option>
          <option :value="true">Да</option>
          <option :value="false">Нет</option>
        </select>
      </div>
      <div class="col d-flex align-items-center">
        <div class="row d-flex align-items-center flex-nowrap">
          <div class="col" v-for="pt in $root.paymentTypes">
            <div class="d-flex flex-column align-items-center">
              <label :for="'ptcheck_'+pt.Id" class="">
                {{pt.Name}}
              </label>
              <input :id="'ptcheck_'+pt.Id" :value="pt.Id" class="" type="checkbox"
                     v-model="currentPaymentTypes">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoading">
      <h1>Загрузка</h1>
    </div>
    <div v-if="!isLoading && !orders.length">
      <h1>Нет заказов</h1>
    </div>
    <div v-if="orders.length && !isLoading">
      <div class="font-weight-bold mb-3" style="font-size: 1.2rem">
      <span class="mr-5" v-for="(pt, key) in ptByKeys">
        {{pt.Name}} - {{totals[key] || 0}}
      </span>
      <span class="mr-5">Итого - {{totalSum(totals)}}</span>
      </div>
      <div class="mb-3">
        <button type="button" class="btn btn-info toggle-margin-btn" id="btn-copy-table" data-clipboard-target="#order-table-list">Копировать таблицу</button>
      </div>
      <table class="table table-hover table-bordered table-sm" id="order-table-list">
        <thead>
        <tr>
          <th width="130">ID</th>
          <th width="130">Номер</th>
          <th width="130">Клиентский номер</th>
          <th width="300">Пункт</th>
          <th width="1000">Наименование</th>
          <th width="100">Статус</th>
          <th width="100">Оплачено</th>
          <th width="100">Получено</th>
          <th width="100">Дата отправки</th>
          <th width="100">Дата доставки</th>
          <th width="100">Курьер</th>
          <th width="100">Цена</th>
          <template v-for="(pt, key) in ptByKeys">
            <th width="100">{{pt.Name}}</th>
          </template>
          <th>Долг</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in orders">
          <td>{{order.Id}}</td>
          <td class="overflow-hidden text-nowrap" style="max-width: 0;">{{order.RecastNumber > 0 ? 'Переделка заказа ' : ''}} {{order.SferaNumber}}</td>
          <td class="overflow-hidden text-nowrap" style="max-width: 0;">{{order.LocalNumber}}</td>
          <td class="overflow-hidden text-nowrap" style="max-width: 0; text-overflow: ellipsis;">{{order.Reception}}</td>
          <td class="overflow-hidden text-nowrap" style="max-width: 0; text-overflow: ellipsis;">{{order.Name}}</td>
          <td class="text-nowrap">{{order.OrderStatusName}}</td>
          <td class="text-nowrap">{{order.PaidDate}}</td>
          <td class="text-nowrap">{{order.PassedDate}}</td>
          <td class="text-nowrap">{{order.DispatchDate}}</td>
          <td class="text-nowrap">{{order.DeliveryDate}}</td>
          <td>{{order.CourierFname}} {{order.CourierLname}} {{order.CourierMname}}</td>
          <td>{{order.Summary}}</td>
          <template v-for="(pt, key) in ptByKeys">
            <td width="100">{{order.PaymentTypeId == key ? order.Summary : ''}}</td>
          </template>
          <td>{{!order.PaidDate ? order.Summary : ''}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';
import ClipboardJS from 'clipboard';

const queryString = require('query-string');

const defaultDateFrom = moment().format('YYYY-MM-DD');
// const defaultDateFrom = moment().format('YYYY-MM-DD');
const defaultDateTo = moment().format('YYYY-MM-DD');


export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      orders: [],
      from: defaultDateFrom,
      to: defaultDateTo,
      customerCategories: [],
      orderStatuses: [],
      currentCustomerCategory: null,
      currentOrderStatus: null,
      isPaid: '',
      isPassed: '',
      page: 1,
      per_page: 100,
      links: [],
      isLoading: false,
      currentPaymentTypes: [],
      dateMode: 'delivery_date',
    };
  },
  async mounted() {
    await this.fetchCustomerCategories();
    await this.fetchOrderStatus();
    const status = _.findLast(this.orderStatuses, o => o.Code === 'in_dispatch');
    this.currentOrderStatus = status.Id;
    await this.fetchOrderTableList();
    const clipboard = new ClipboardJS('#btn-copy-table');
    clipboard.on('success', function(e) {
      e.clearSelection();
    });
  },
  computed: {
    totals() {
      if (!this.orders.length) return {};
      const groups = _.groupBy(this.orders, o => o.PaymentTypeId);
      return _.mapValues(groups, g => _.sumBy(g, o => +o.Summary));
    },
    ptByKeys() {
      return _.mapKeys(_.cloneDeep(this.$root.paymentTypes), (v, k) => v.Id);
    },
  },
  watch: {
    async from(newVal) {
      if (newVal !== this.to) {
        this.to = newVal;
      } else {
        await this.fetchOrderTableList();
      }
    },
    async dateMode(newVal) {
      if (newVal && this.from && this.to) {
        await this.fetchOrderTableList();
      }
    },
    async to(newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.fetchOrderTableList();
      }
    },
    async currentCustomerCategory() {
      await this.fetchOrderTableList();
    },
    async currentOrderStatus() {
      await this.fetchOrderTableList();
    },
    async isPaid() {
      await this.fetchOrderTableList();
    },
    async isPassed() {
      await this.fetchOrderTableList();
    },
    async page() {
      await this.fetchOrderTableList();
    },
    async currentPaymentTypes() {
      await this.fetchOrderTableList();
    },
  },
  methods: {
    totalSum(pts) {
      return _.sum(_.values(pts));
    },
    async fetchCustomerCategories() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/customer-category`);
      this.customerCategories = data.data;
    },
    async fetchOrderStatus() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-status`);
      this.orderStatuses = data.data;
    },
    async fetchOrderTableList() {
      this.isLoading = true;
      this.orders = [];
      this.total = 0;
      this.links = [];
      const query = queryString.stringify({
        dateMode: this.dateMode,
        from: this.from,
        to: this.to,
        currentCustomerCategory: this.currentCustomerCategory,
        currentOrderStatus: this.currentOrderStatus,
        isPaid: this.isPaid,
        isPassed: this.isPassed,
        page: this.page,
        perPage: this.per_page,
        currentPaymentTypes: this.currentPaymentTypes,
      }, {
        arrayFormat: 'bracket',
      });
      try {
        const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order/table-list?${query}`);
        this.orders = data.orders;
        this.total = data.total;
        this.links = data.links;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss">
  .toggle-margin-btn {
    margin-bottom: 0;
    margin-top: 0;
    &:active {
      margin-bottom: -3px;
      margin-top: 3px;
    }
  }
</style>
